import { createReducer, on } from '@ngrx/store';
import { authInitialState } from '@store/states/auth.state';
import { authActions } from '@store/actions/auth.actions';

export const authReducer = createReducer(
  authInitialState,
  on(authActions.attemptLogin, (state, { idp }) => ({ ...state, idp: idp ?? null })),
  on(authActions.loginSuccessful, (state, { idp }) => ({ ...state, idp: idp })),
  on(authActions.loggedOut, (state) => ({ ...state, idp: null })),
  on(authActions.ongoingAuthCheck, (state, { checking }) => ({ ...state, checkingAuth: checking }))
);
